import { vnModule_knockoutJS } from "../../vendor/valnet/valnet_jslib/vnApp/vnModule_knockoutJS";
import { XMLHttpRequestHandler } from "../../vendor/valnet/valnet_jslib/XMLHttpRequestHandler/XMLHttpRequestHandler";
import {appHeaderPwa_template} from "../components/templates/appHeaderPwa_template";
import {vnApp_emaki} from "../components/vnApp_emaki";

declare var page: any;
declare var ko: any;
export class header_pwa extends vnModule_knockoutJS{


    public appHeader: appHeaderPwa_template;
    protected XHRHdl: XMLHttpRequestHandler;
    protected XHRHdls: XMLHttpRequestHandler[] = [];

    protected getModuleName(){
        return "header-pwa";
    }

    buildContent() : Array<Element>{

        let vnApp = this.getVnAppZone().app;

        //
        // Only if were logged in
        if(vnApp.loggedUser != null && vnApp.loggedUser.isLoggedIn) {

            this.appHeader = new appHeaderPwa_template("mainHeader", this.viewModel, this);

            // set picture
            if( vnApp.loggedUser.user.valnet_user.pictureUrl ){
                this.appHeader.setUserImageSrc("/usersImages/" + vnApp.loggedUser.user.pictureUrl);
            }
            else{
                this.appHeader.setUserImageSrc("/assets/images/default-user.png");
            }

            // set full name
            this.appHeader.setUserFullName(vnApp.loggedUser.user.valnet_user.firstName +' '+ vnApp.loggedUser.user.lastName);

            // set profile page link
            this.appHeader.setProfilePageLink("/users/edit/"+ vnApp.loggedUser.user.id);

            return [this.appHeader.build()]
        }
        else{
            return [document.createElement("div")];
        }
    }


    public fillPage() : void{
        let vnApp = this.getVnAppZone().app;
        if(vnApp.loggedUser != null && vnApp.loggedUser.isLoggedIn) {
            this.getMenuData();
        }
    }


    public getMenuData(): void{

        if( 'getMenuData' in this.XHRHdls ){
            this.XHRHdls['getMenuData'].cancelAndReset();
        }

        let subViewModel = JSON.parse(ko.toJSON({menu: 'main'}));
        let usrReq_params: Array<Array<string>> = [];
        usrReq_params.push(['data', ko.toJSON(subViewModel)]);

        let usrReq_url: string = '/api/emaki/menu';
        this.XHRHdls['getMenuData'] = new XMLHttpRequestHandler(usrReq_url,usrReq_params, this);

        this.XHRHdls['getMenuData'].onReadyStateFunction = this.onMenuDataRequestReturn;
        this.XHRHdls['getMenuData'].execute();

    }

    protected onMenuDataRequestReturn(req, obj){

        return function(){
            obj.manageResponse(req, obj, function(){

                let response = JSON.parse(req.request.response);
                obj.appHeader.setMenuItems(response.formMenu);
            });
        }
    }

    public logOut(){
        let _mythis = this;

        if( "logOut" in this.XHRHdls ){
            this.XHRHdls["logOut"].cancelAndReset();
        }

        // loading the page if the user is logged in
        let loginReq_url: string = '/api/access/logout/';
        let loginReq_Params: Array<Array<string>> = [];
        this.XHRHdls["logOut"] = new XMLHttpRequestHandler(loginReq_url,loginReq_Params, this);
        this.XHRHdls["logOut"].onReadyStateFunction = (function(req, obj){

            return function(){

                if (req.request.readyState == 4) {

                    if(  req.request.status == 200  ){
                        page.redirect('/');
                    }
                }
            }
        });
        this.XHRHdls["logOut"].execute();
    }

    public setHeaderTitle(title: string){
        this.appHeader.setHeaderTitle(title);
    }

    public setBrandClass(brandClass: string){
        this.appHeader.setBrandClass(brandClass);
    }

    public setBrandName(brandName: string){
        this.appHeader.setBrandName(brandName);
    }

    public setBrandDomain(brandDomain: string){

        this.appHeader.setBrandDomain(brandDomain);

        if (brandDomain.length > 0) {
            if (!brandDomain.startsWith('https://')) {
                brandDomain = 'https://'+brandDomain;
            }
            window.sessionStorage.setItem('currentBrandDomain', brandDomain);
        } else {
            window.sessionStorage.removeItem('currentBrandDomain');
        }
    }

    public isOfRole(role: Number) {
        let show = false;

        let vnApp = this.getVnAppZone().app;
        let roles: Array<any> = this.getVnAppZone().getApp().loggedUser.user.valnet_user.roles;
        let roleIds = [];

        for (let role of roles) {
            roleIds.push(role.id);
        }
        if (roleIds.indexOf(role) > -1) {
            show = true;
        }

        return show;
    }
}



// WEBPACK FOOTER //
// ./js/modules/header_pwa.ts